import { IonIcon } from '@ionic/react';
import { arrowForwardOutline, storefrontOutline } from 'ionicons/icons';
import React from 'react';
import './OnboardingHomeBanner.css';

type OnboardingHomeBannerProps = {
    porcentagem: number;
    totalEtapas: number;
    etapasConcluidas: number;
    onClick: () => void;
};

const OnboardingHomeBanner: React.FC<OnboardingHomeBannerProps> = ({ porcentagem, totalEtapas, etapasConcluidas, onClick }) => (
    <button type="button" className="onboarding-home-banner" onClick={onClick}>
        <span className="onboarding-home-banner-icon"><IonIcon icon={storefrontOutline} aria-hidden="true" /></span>
        <span className="onboarding-home-banner-content">
            <strong className="onboarding-home-banner-title">Vamos deixar sua loja pronta?</strong>
            <span className="onboarding-home-banner-progress">Configuração inicial · {etapasConcluidas} de {totalEtapas} etapas concluídas</span>
            <progress className="onboarding-home-banner-bar" value={porcentagem} max={100} aria-label="Progresso da configuração" />
        </span>
        <span className="onboarding-home-banner-action">Continuar<IonIcon icon={arrowForwardOutline} aria-hidden="true" /></span>
    </button>
);

export default OnboardingHomeBanner;
